import { apiClient } from '@/shared/lib/apiClient';
import type { AnalyticsDashboard } from '../types';

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

export async function fetchAnalyticsDashboard(params?: {
  from?: string;
  to?: string;
}): Promise<AnalyticsDashboard> {
  const res = await apiClient.get<ApiResponse<AnalyticsDashboard>>(
    '/api/v1/admin/analytics/dashboard',
    {
      params: {
        ...(params?.from ? { from: params.from } : {}),
        ...(params?.to ? { to: params.to } : {}),
      },
    },
  );
  return res.data;
}
